import React from 'react';
import styled from '@emotion/styled';
import { Paper } from '../../../../../../ui';
import { Features } from './Features';
import { ICategory } from './types';
import { INestedInputLevel } from '../nested-input/INestedInputLevel';
import { NestedInputId } from '../nested-input/NestedInputId';
import { Subcategories } from './Subcategories';
import { MoreInformation } from '../more-information';
import Responsive from '../../../../../../ui/utils/Responsive';

export interface ICategoryProps<TCategoryId, TSubcategoryId> {
	category: ICategory<TCategoryId, TSubcategoryId>;
	defaultSubcategoryId?: TSubcategoryId;
	nestedInputLevel: INestedInputLevel;
}

export const Category = <
	TCategoryId extends string | number,
	TSubcategoryId extends string | number,
>({
	category,
	defaultSubcategoryId,
	nestedInputLevel,
}: ICategoryProps<TCategoryId, TSubcategoryId>) => {
	const { title, features, subtitle, moreInformation, subcategories } =
		category;

	return (
		<CategoryWrap>
			<h3>{title}</h3>
			{features && <Features features={features} />}
			{subtitle && (
				<Subtitle>
					{subtitle}
					{moreInformation && <MoreInformation text={moreInformation} />}
				</Subtitle>
			)}
			<NestedInputId level={nestedInputLevel} value={category.id} />
			<Subcategories
				categoryId={category.id}
				subcategories={subcategories}
				defaultSubcategoryId={defaultSubcategoryId}
			/>
		</CategoryWrap>
	);
};

const CategoryWrap = styled(Paper)`
	margin-top: 40px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: 24px;
	}

	&:first-of-type {
		margin-top: 0;
	}
`;

const Subtitle = styled.h4`
	font-size: 20px;
	color: #000;
`;
